import React from "react";
import "./Policy.css";
const PrivacyPolicy = () => {
  return (
    <div className="policyContainer">
      <div className="policyHead">
        <h2>
          Privacy <span>Policy</span>
        </h2>
      </div>
      <div className="policyContent">
        <p>
          Prizma Academy makes every effort to handle your personal information
          as safely and securely as reasonably possible.
        </p>
        <p>
          When you visit our websites or use our services, you’re trusting us
          with your information and we fully understand that this is a big
          responsibility and we take all reasonable measures to safeguard and
          protect your information.
        </p>
        <p>
          This Privacy Policy is meant to help you understand what information
          we collect, why we collect it, and how you can update and manage your
          information.
        </p>
        <p>
          As described below, your information may be collected by Prizma
          Academy, disclosed to third parties, and used by third parties and
          Prizma Academy. This Privacy Policy describes the information we
          collect from you and how we may use that information.
        </p>
        <ul>
          <h3>
            Some of the reasons why we collect your personal information
            include:
          </h3>
          <li>
            To register you so that you access parts and services of the Prizma
            Academy sites;
          </li>
          <li>To register you so that you may use access “Mobile” App;</li>
          <li>To register you so that you may subscribe to our newsletters;</li>
          <li>
            So that you may participate in discussion forums and blogs on our
            site;
          </li>
          <li>
            To perform verification / validation of identity, where applicable;
          </li>
          <li>
            To provide you with timely and relevant information through
            post/courier, SMS, Telephone/GSM, E-Mail and social media channels;
          </li>
          <li>
            To provide you with a more personalized and meaningful experience on
            the Prizma Academy sites.
          </li>
        </ul>
        <p>
          We occasionally employ other companies and individuals to perform
          functions on our behalf. For example, other companies and individuals
          may fulfill your orders from us, send you postal mail and e-mail,
          remove repetitive information from our customer lists, analyze our
          data, provide us with marketing assistance, and process credit card
          payments. These third-party service providers have access to personal
          information needed to perform their functions, and may not use it for
          other purposes.
        </p>
        <p>
          We do not sell, rent, share, or otherwise disclose personally
          identifiable information of our customers for commercial purposes. We
          do not intend to disclose any personal information of yours without
          your consent to any third party who is not bound to act on our behalf
          unless such disclosure is required by law.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
